import { EditAiPersonaPage } from "@/features/ai/edit-ai-persona.page";
import { ProjectRoute } from "@/routes/_authenticated/workspaces/$slug/projects/$projectSlug";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/ai-team/$personaId",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { project } = ProjectRoute.useRouteContext();
  const { personaId } = useParams({
    from: "/_authenticated/workspaces/$slug/projects/$projectSlug/ai-team/$personaId",
  });

  return <EditAiPersonaPage containerId={project.id} personaId={personaId} />;
}
